/* eslint-disable */ 
import { createApp } from 'vue'

import {createRouter,createWebHashHistory}        from 'vue-router'
/* import { defineStore } from 'pinia' */
import { createStore } from 'vuex'

//import App from './App.vue'
import com_app_instalacion        from '@/components/app_instalacion/com_app_instalacion'
import com_general      from '@/components/general/com_general'
import com_inicio       from '@/components/inicio/com_inicio'
import com_login        from '@/components/login/com_login'
import com_productos    from '@/components/productos/com_productos'
import com_compras      from '@/components/compras/com_compras'
import com_compras_ticket       from '@/components/compras/ticket/com_compras_ticket'
import com_cuentas_bancarias      from '@/components/cuentas_bancarias/com_cuentas_bancarias'
import com_ventas      from '@/components/ventas/com_ventas'
import com_ventas_ticket       from '@/components/ventas/ticket/com_ventas_ticket'
import com_caja      from '@/components/caja/com_caja'
import com_otros_movimientos      from '@/components/otros_movimientos/com_otros_movimientos'
import com_inventarios      from '@/components/inventarios/com_inventarios'

import sonido_abrir   from '@/lobato/general/audio/sonido-abre.mp3'
import sonido_agregar from '@/lobato/general/audio/sonido-agregar.mp3'
import sonido_remover from '@/lobato/general/audio/sonido-remover.mp3'
import sonido_success from '@/lobato/general/audio/sonido-success.mp3'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
import * as calculos  from '@/librerias/lobato-calculos.js'

const store = createStore({
    state () {
      return {
        general:{
            sonidos:{
                abrir:  new Audio(sonido_abrir),
                agregar:new Audio(sonido_agregar),
                remover:new Audio(sonido_remover),
                success:new Audio(sonido_success)
            },
            pwa:{
                evento_instalacion_pwa:'',
                boton_instalar:{
                    mostrar:false,
                }
            },
            roles:{
                rol1:false,//administrador
                rol2:false//caja
            },
            usuario:{
                nombre:'',
                apellido_paterno:'',
                apellido_materno:'',
                rol:''
            },            
            verificacion_rol:{
                inventario:{
                    col_inv_acu:false,
                    col_can_mon:false
                },
                caja:{
                    input_saldo_inicial:false
                },
                otros_movimientos:{
                    option_ingreso:false
                },
                app:{                    
                    boton_datos_basicos:false,
                    boton_nominas:false,
                    boton_cotizaciones:false,
                    boton_cuentas_bancarias:false            
                }
            },
            otros:{
                conexion_internet:{
                    estado:false
                },  
                //dominio_server:'',
                //dominio_server  :'https://local.compra_venta_metales_backend.com',                    
                dominio_server:'https://metales-backend.destab.icu',
                dominio         :location.origin,
                pathname        :location.pathname,
                csrf:'',//document.getElementById('mi_csrf').value,
                token:'',  
                autenticado:'',  
                app_modo:'',//local,online,                            
                usuario:{
                    //rol:'',//document.getElementById('mi_rol').value,
                    //id:'',//document.getElementById('mi_id').value,
                    nombre:'',
                    apellido_paterno:'',
                    apellido_materno:'',
                    clave_visualizar:''
                },
                funciones:{
                    atributo:(item,atributo)=>{
                        return item.target.getAttribute(atributo);
                    }
                }
            } 
        }
      }
    },
    mutations: {
        revisar_entrada(state,dato)
        {
            return dato===null ? '' : dato===undefined ? '' : dato;
        },
        funciones(state,parametros)
        {
            let funciones={
                sonido:(parametros)=>
                {
                    let audioElement=parametros.sonido;
                    audioElement.play();
                },
                alerta:(parametros)=>
                {
                    if(['success'].includes(parametros.estatus))
                    {
                        //funciones.sonido({sonido:`sonido-${parametros.estatus}.mp3`});
                        funciones.sonido({sonido:state.general.sonidos.success});
                    }
                    Swal.fire({
                        position: 'top-end',
                        icon: parametros.estatus,
                        title: parametros.mensaje,
                        showConfirmButton: false,
                        timer: 2500
                    })
                },
                cargar_imagen_local:(parametros)=>{
                    let dt={
                        //img:document.getElementById(`material-imagen${material_index}`).files
                        img:document.getElementById(parametros.elemento_html).files
                    };
                    if(dt.img.length>0)
                    {
                        const imagen = new Image();
                        imagen.onload = () => {
                            const canvas    =document.createElement("canvas");
                            canvas.width    =parametros.medidas.ancho; //imagen.width;
                            canvas.height   =parametros.medidas.altura; //imagen.height;
                            canvas.getContext("2d").drawImage(
                                imagen, 0, 0, 
                                parametros.medidas.ancho,
                                parametros.medidas.altura
                            );
                            canvas.toBlob(
                                (blob) => {
                                    if (blob === null) {
                                        //console.log('here 1');
                                        parametros.destino.archivo='';
                                        parametros.destino.url='';
                                    } else {
                                        //console.log('here 2');
                                        //console.log(blob);
                                        //console.log(parametros);
                                        parametros.destino.archivo=blob;
                                        parametros.destino.url=URL.createObjectURL(blob);
                                        funciones.sonido({sonido:state.general.sonidos.agregar});
                                        //this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
                                    }
                                    //document.getElementById(`material-imagen${material_index}`).value='';
                                    document.getElementById(parametros.elemento_html).value='';
                                },
                                "image/jpeg",
                                0.9
                            );
                        }
                        imagen.src = URL.createObjectURL(dt.img[0]);
                        document.getElementById(parametros.elemento_html).value='';
                    }
                },
                revisar_entrada:(parametro)=>{
                    //var a= parametro.dato===null ? '' : parametro.dato===undefined ? '' : parametro.dato;
                    parametro.destino[parametro.destino_propiedad]= 
                    parametro.dato_evaluar===null ? parametro.dato_alterno : parametro.dato_evaluar===undefined ? parametro.dato_alterno : parametro.dato_evaluar;
                }                
            };
            if(parametros.nombre in funciones)
            {
                funciones[parametros.nombre](parametros);
            }
        },
        alerta(datos)
        {
            let timerInterval
            Swal.fire({
            allowOutsideClick:false,
            allowEscapeKey:false,
            title: datos.titulo,
            html: datos.mensaje,
            //timer: 2000,
            timerProgressBar: true,
            onBeforeOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => {
                const content = Swal.getContent()
                if (content) {
                    const b = content.querySelector('b')
                    if (b) {
                    b.textContent = Swal.getTimerLeft()
                    }
                }
                }, 100)
            },
            onClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
                console.log('I was closed by the timer')
            }
            })
        },
        verificacion_rol(state)
        {
            let r=state.general.usuario.rol;
            let v=state.general.verificacion_rol;
            

            let dt={
                'caja':()=>{

                },
                'administrador':()=>{

                    v.inventario.col_inv_acu=true;
                    v.inventario.col_can_mon=true;
                    v.caja.input_saldo_inicial=true;
                    v.otros_movimientos.option_ingreso=true;
                    v.app.boton_datos_basicos=true;
                    v.app.boton_nominas=true;
                    v.app.boton_cotizaciones=true;
                    v.app.boton_cuentas_bancarias=true;
                    

                }
            };

            if(r in dt )
            {
                dt[r]();
            }

        }
    },
    getters:{
        general_fecha_hoy()
        {
            let fechaActual = new Date();
            let ano = fechaActual.getFullYear();

            let mes = fechaActual.getMonth() + 1;
            mes=mes<10 ? `0${mes}` : mes;

            let dia = fechaActual.getDate();
            dia=dia<10 ? `0${dia}` : dia;

            let fecha = `${ano}-${mes}-${dia}`;
            
            return fecha;   
        },
        //general_revisar_texto()
        general_no_xss()
        {
            let b=(t)=>{                
                let a='';
                if(t===null)
                {
                    a='';
                }
                else
                {
                    /* let lista=[
                        '<script>',
                        '</script>',
                        'localStorage',
                        'console'
                    ]; */

                    let lista = [
                        '<script>', '</script>', // Bloquea etiquetas de script
                        'localStorage', 'sessionStorage', // Evita acceso a almacenamiento del navegador
                        'document.cookie', 'window.cookie', // Previene robo de cookies
                        'onerror=', 'onload=', 'onclick=', 'onmouseover=', 'onfocus=', // Bloquea eventos JavaScript peligrosos
                        'javascript:', 'data:', 'vbscript:', // Previene ejecución de código arbitrario en enlaces
                        'new Function(', 'eval(', 'setTimeout(', 'setInterval(', // Bloquea métodos inseguros de ejecución de código
                        '<iframe>', '</iframe>', '<object>', '</object>', '<embed>', '</embed>', // Evita inserción de contenido externo
                        '<img src=', '<a href=', '<link href=', // Protege contra enlaces y cargas de recursos maliciosos
                        'innerHTML', 'outerHTML', 'document.write', // Evita manipulación directa del DOM
                        'XMLHttpRequest', 'fetch', 'WebSocket', // Previene uso malicioso de APIs para exfiltración de datos
                        'atob(', 'btoa(', 'decodeURIComponent(', 'encodeURIComponent(', // Limita manipulación de datos en ataques sofisticados
                        '%3Cscript%3E', '%3C/script%3E', '%3Cimg%20src=', '%3Ciframe%3E' // Versiones **url encoded** para evitar bypass de filtros
                    ];

                    lista.forEach((item,index)=>{

                        t=t.replace(item,'');

                    });
                    a=t;
                }
                return a;
            };
            return b;
        },
        general_formato_moneda()
        {
           let b=(m)=>{
                m=calculos.revisar_numero(m);
                return (m).toLocaleString("es-MX",{
                    style: 'currency',
                    currency: 'MXN'
                });
           }; 
           return b;
        }/*,
        general_ubicacion_actual()
        {
            let b=()=>{

                return new Promise(resolve,reject)=>{

                    let ubicacion='';
                    let funcion_success=(position) => {
                        //ubicacion.lat=position.coords.latitude;
                        //ubicacion.lng=position.coords.longitude;
                        ubicacion=position;
                    };
                    let funcion_error=(error)=>{
                        ubicacion='error: '+error
                    };

                    navigator.geolocation.getCurrentPosition(funcion_success,funcion_error);
                    return ubicacion;
                };

            };
            return b;

        }*/

        /* formatear_moneda(state,m)
        {
            //m=calculos.revisar_numero(m);
            m=parseFloat(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        } */
        /* formatear_moneda:(state) => (number) => { 
            return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(number);
        } */
    }
});


const routes=[
    {path:'/app'            ,component:com_app_instalacion    ,name:'r-app'},
    {path:'/login'          ,component:com_login    ,name:'r-/login'},
    //{path:'/'               ,component:com_inicio   ,name:'r-/'},
    {path:'/'               ,component:com_inicio   ,name:'r-/'},/* 
    {path:'/usuarios'       ,component:com_usuarios ,name:'r-usuarios'},
    //{path:'/clientes/:id'   ,component:com_clientes,name:'r-clientes'},
    {path:'/clientes'       ,component:com_clientes ,name:'r-clientes'},*/
    {path:'/productos'      ,component:com_productos,name:'r-productos'},
    /*{path:'/productos/categorias'      ,component:com_productos_categorias,name:'r-productos/categorias'},*/    
    {path:'/compras'      ,component:com_compras,name:'r-compras'},
    {path:'/compras/:id/ticket'    ,component:com_compras_ticket,name:'r-compras/*/ticket'},    
    {path:'/cuentas_bancarias'      ,component:com_cuentas_bancarias,name:'r-cuentas_bancarias'},
    {path:'/ventas'      ,component:com_ventas,name:'r-ventas'},
    {path:'/ventas/:id/ticket'    ,component:com_ventas_ticket,name:'r-ventas/*/ticket'},
    {path:'/caja'           ,component:com_caja,name:'r-caja'},
    {path:'/otros_movimientos'  ,component:com_otros_movimientos,name:'r-otros_movimientos'},
    {path:'/inventarios'      ,component:com_inventarios,name:'r-inventarios'},


];
const router=createRouter({
    history:createWebHashHistory(),
    routes
});

//createApp(App).mount('#app')
const app=createApp(com_general)
app.use(store)
app.use(router)


app.mount('#app')
